"use strict";

function blog() {
  var archiveWrapper = document.querySelector('.c-blog');
  if (!archiveWrapper) {
    return;
  }
  var container = document.querySelector('.c-blog__posts');
  if (container) {
    var infiniteScroll = new InfiniteScroll(container, {
      path: '.c-blog__pagination__link',
      button: '.c-blog__pagination__link',
      append: '.c-blog__post',
      history: false,
      scrollThreshold: false
    });
    var button = document.querySelector('.c-blog__pagination__link');
    if (infiniteScroll && button) {
      infiniteScroll.on('request', function () {
        button.innerHTML = 'Loading...';
      });
      infiniteScroll.on('load', function () {
        button.innerHTML = 'Load more';
      });
    }
  }
}
blog();